module.exports = __webpack_public_path__ + "static/media/hakeemonibudo.4e676d12.png";